<script setup lang="ts">
import { useGenerateIds } from '../composables';

//simulate old {% box %} macro, but only handle either both classes (horizontal) or none (vertical, inline)
const props = defineProps<{
    id?: string;
    name?: string;
    label?: string | boolean;
    labelClass?: string;
    controlClass?: string;
    plain?: boolean;
}>();

const generateIds = useGenerateIds();

const controlId = props.id || generateIds();
const controlName = props.name || controlId;

</script>
<template>
    <Component
        :is="((props.labelClass && props.controlClass) || props.plain) ? 'span' : 'div'"
        :class="((props.labelClass && props.controlClass) || props.plain) ? '' : 'form-group'"
    >
        <label v-if="props.label" :for="controlId" :class="props.labelClass" class="control-label">
            <slot name="label">{{ props.label }}</slot>
        </label>
        <div v-if="props.controlClass" :class="props.controlClass">
            <slot :nameprops="{id: controlId, name: controlName}" />
        </div>
        <slot v-else :nameprops="{id: controlId, name: controlName}" />
    </Component>
</template>
